import React, { useEffect, useRef, useState } from 'react';
import { useAISuggestionStore } from 'store/ai-suggestion';

export const useAISuggestion = () => {
  const [isAIButtonShown, setIsAIButtonShown] = useState(false);
  const [isAISuggestionBlockShown, setIsAISuggestionBlockShown] =
    useState(false);
  const { setActiveAISuggestion } = useAISuggestionStore((store) => store);
  const AIButtonRef = useRef(null);

  useEffect(() => {
    setActiveAISuggestion(null);
  }, [setActiveAISuggestion]);

  const onInputBlur = (event: React.FocusEvent) => {
    const isAIButtonFocusedNext = event.relatedTarget === AIButtonRef.current;

    if (!isAIButtonFocusedNext) {
      setIsAIButtonShown(false);
    }
  };

  const onInputFocus = () => {
    setIsAIButtonShown(true);
  };

  const onAIButtonBlur = () => {
    if (!isAISuggestionBlockShown) {
      setIsAIButtonShown(false);
    }
  };

  const onAIButtonClick = () => {
    setIsAISuggestionBlockShown(true);
  };

  const onAISuggestionBlockClose = () => {
    setIsAIButtonShown(false);
    setActiveAISuggestion(null);
    setIsAISuggestionBlockShown(false);
  };

  const data = {
    isAIButtonShown,
    isAISuggestionBlockShown,
    AIButtonRef,
  };

  const handlers = {
    onInputBlur,
    onInputFocus,
    onAIButtonBlur,
    onAIButtonClick,
    onAISuggestionBlockClose,
  };

  return {
    data,
    handlers,
  };
};
